export const canShowCheckboxColumn = (permissions: Record<string, unknown> | undefined) =>
  Boolean(permissions?.editJobs || permissions?.submitJobs || permissions?.deleteJobs);
